export const PARAM_KEY = "userAgent";
export const ADDON_ID = "storybook/user-agent";
export const TOOL_ID = `${ADDON_ID}/tool`;
export const TOOL_TITLE = "User-Agent";
